module.exports = __webpack_public_path__ + "img/tema-3-11.c2dfcfcf.svg";